import Model, { ID, MODEL_LEVEL } from 'src/models/model'

export default class UserStripeCustomer extends Model {
  static name = 'UserStripeCustomer'

  static level = MODEL_LEVEL.CIRCUIT

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        output: true
      },
      standardConnectAccountId: {
        type: String,
        default: null,
        output: true
      },
      customerId: {
        type: String,
        required: true,
        output: true
      },
      defaultPaymentMethodId: {
        type: String,
        default: null,
        output: true
      },
      defaultPaymentMethodFingerprint: {
        type: String,
        default: null,
        output: true
      },
      defaultPaymentMethodLast4: {
        type: String,
        default: null,
        output: true
      },
      defaultPaymentMethodBrand: {
        type: String,
        default: null,
        output: true
      }
    }
  }
}
